/**
 * Parcels Details
 */

// React
import React, {useState, useEffect} from 'react';
import Client from 'client-sdk/src/client';
// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../redux/reducers';
import {
  getRonadParcelsWithIdAction,
  getParcelInventoryItemsAction,
  cleanPercelInventoryItemsAction,
} from '../parcelLogs/actions';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectParcel,
  makeSelectLoading,
  makeSelectError,
  makeSelectInventoryItemsList,
  makeSelectInventoryItemsLoading,
} from '../parcelLogs/selectors';

import {
  makeSelectLoading as makeDriverLoading,
  makeSelectDriversList,
} from '../drivers/selectors';

//UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import {Autocomplete} from '@material-ui/lab';

// Icon
import Icon from '@mdi/react';
import {
  mdiKeyOutline,
  mdiWarehouse,
  mdiArrowRight,
  mdiPackage,
  mdiPhoneOutline,
  mdiCalendar,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPlusBoxMultipleOutline,
  mdiPrinter,
  mdiCar,
} from '@mdi/js';

// Components
import {Controller, useForm} from 'react-hook-form';

// Helper
import {formaterPhoneNumber} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
// import {Status} from '../orders/interfaces';
import {SelectorProps, Props} from './interfaces';
import {GetAllVehiclesRequestBuilder} from 'client-sdk/src/vehicles/vehicles';
import {cleanDriverListAction, getDriversAction} from '../drivers/actions';
import {AssignParcelToDriverRequestBuilder} from 'client-sdk/src/parcels/parcels';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';

interface Inputs {
  vehicleType: string;
  driverName: string;
  driverId: number | string;
  driverPhone: string;
}

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      width: '100%',
    },
    inputHolder: {
      flex: 1,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
  })
);

export function PickupsDetails(props: Props) {
  const token = localStorage.getItem('token') || '';
  const classes = useStyles();
  const {control, handleSubmit, errors, setValue} = useForm<Inputs>();
  const [confirmModal, setConfirmModal] = useState(false as boolean);
  const [Data, setData] = useState<null | Inputs>(null);
  const [loading, setLoading] = useState(false as boolean);
  const [parcel, setParcel] = useState([]);

  const handleOpenConfirmModal = () => setConfirmModal(true);
  const handleCloseConfirmModal = () => {
    setConfirmModal(false);
  };
  useEffect(() => {
    const {id} = props.match.params;
    // props.getParcelWithIdActionDispatch(id);
    getParcel(id)

  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (parcel) {
      setValue('vehicleType', parcel?.driverVehicleKlass);
      setValue('driverId', parcel?.driverId);
      setValue('driverName', parcel?.driverName);
      setValue('driverPhone', parcel?.driverMobile);

      if (parcel?.driverVehicleKlass) {
        getVehicles(parcel?.driverVehicleKlass);
      }
    }
  }, [parcel]);

  const getParcel = async (id:number) => {
    const payload = {id}
    try {
      const parcel = await parcelsRepository.getParcelsWithId({payload})
      setParcel(parcel.data)
    }catch(err) {
      handleError(err)
    }
  }

  const handleFormSubmit = (data: Inputs) => {
    setData(data);
    handleOpenConfirmModal();
  };

  const handleChangeType = (value: string) => {
    getVehicles(value);
    setValue('driverId', '');
    setValue('driverName', '');
    setValue('driverPhone', '');
  };

  const getVehicles = async (type: string) => {
    try {
      const vehiclesRequest = new GetAllVehiclesRequestBuilder()
        .params({'klass.equals': type})
        .build();
      const client = new Client(token);
      const {data} = await client.execute(vehiclesRequest);
      if (data) {
        props.getDriversDipatch({'vehicleId.in': data.map(el => el.id)});
      }
    } catch (err) {
      handleError(err.response);
    }
  };

  const handleSelectDriver = (value: string) => {
    setValue('driverName', value);
    const selectedDriver = props.driverList.find(el => el.name === value);
    if (selectedDriver) {
      setValue('driverPhone', selectedDriver.phoneNumber);
      setValue('driverId', selectedDriver.id);
    }
  };

  const handleAssignParcel = async () => {
    try {
      setLoading(true);
      const assignmentRequest = new AssignParcelToDriverRequestBuilder()
        .id(props.match.params.id)
        .data(Data?.driverId)
        .build();
      const client = new Client(token);
      const data = await client.execute(assignmentRequest);
      handleNotfication('محموله با موفقیت به راننده اختصاص داده شد', 'success');
      props.history.push('/pickups');
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات محموله 
        ${parcel.id}`}
        </Typography>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {`بازگشت`}
        </Button>
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {`نام شرکت:  `}
              </span>

              <span>{parcel.partnerName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {`تاریخ جمع‌آوری:  `}
              </span>
              <span>
                <span>
                  {parcel.ronadTransportationDTO &&
                    `${jMoment(
                      parcel?.ronadTransportationDTO?.pickDate,
                      'YYYY/MM/DD'
                    )
                      .locale('fa')
                      .format('jYYYY/jMM/jDD')}`}
                </span>
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarClock}
                  size={1}
                  className={classes.icon}
                />
                {`ساعت جمع‌آوری:  `}
              </span>
              <span>
                <span>
                  {parcel.ronadTransportationDTO &&
                    jMoment(
                      parcel?.ronadTransportationDTO?.pickTime,
                      'hh:mm'
                    )
                      .locale('fa')
                      .format('HH:mm')}
                </span>
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiPackage} size={1} className={classes.icon} />
                {`تعداد بسته:  `}
              </span>

              <span>{parcel.boxCount}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiPackage} size={1} className={classes.icon} />
                {`مجموع وزن:  `}
              </span>

              <span>{parcel.weight}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {`آدرس محل جمع‌آوری :  `}
              </span>
              <span>{parcel?.ronadTransportationDTO?.pickAddress}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {`نام انبار مقصد:  `}
              </span>

              <span>{parcel?.destinationName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {`تاریخ تحویل به انبار:  `}
              </span>
              <span>
                <span>
                  {parcel.shippingDate &&
                    `${jMoment(parcel.deliveryDate, 'YYYY/MM/DD')
                      .locale('fa')
                      .format('jYYYY/jMM/jDD')}`}
                </span>
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPhoneOutline}
                  size={1}
                  className={classes.icon}
                />
                {`تلفن انبار مقصد:  `}
              </span>
              <span>
                {formaterPhoneNumber(parcel.destinationPhoneNumber)}
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {`آدرس محل تخلیه :  `}
              </span>
              <span>{parcel.destinationAddress}</span>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Paper
          elevation={3}
          className={classes.paper}
          variant="elevation"
          square
        >
          <Grid container spacing={3}>
            <Grid
              container
              item
              xs={12}
              sm={6}
              md={3}
              lg={3}
              alignItems="flex-end"
            >
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon path={mdiCar} size={1} className={classes.icon} />
                  <InputLabel className={classes.label} id="vehicleType">
                    نوع خودرو
                  </InputLabel>
                </span>
                <span className={classes.inputHolder}>
                  <Controller
                    style={{width: '100%', marginBottom: '8px'}}
                    name="vehicleType"
                    control={control}
                    defaultValue={
                      parcel?.driverVehicleKlass
                        ? parcel?.driverVehicleKlass
                        : ''
                    }
                    rules={{required: true}}
                    render={({onChange, value}) => (
                      <Select
                        value={value}
                        style={{width: '100%'}}
                        onChange={e => {
                          onChange(e);
                          handleChangeType(e.target.value);
                        }}
                      >
                        <MenuItem value={'CAR'}>سواری</MenuItem>
                        <MenuItem value={'MOTORCYCLE'}>موتورسیکلت</MenuItem>
                        <MenuItem value={'PICKUPS'}>وانت</MenuItem>
                        <MenuItem value={'TRUCK'}>کامیون سبک</MenuItem>
                        <MenuItem value={'HEAVY_TRUCK'}>کامیون سنگین</MenuItem>
                        <MenuItem value={'AIRPLANE'}>هواپیما</MenuItem>
                      </Select>
                    )}
                  />
                  <FormHelperText error focused>
                    {errors.vehicleType && 'نوع خودرو الزامی است'}
                  </FormHelperText>
                </span>
              </div>
            </Grid>
            <Grid
              container
              item
              xs={12}
              sm={6}
              md={3}
              lg={3}
              alignItems="flex-end"
            >
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon
                    path={mdiMapMarkerOutline}
                    size={1}
                    className={classes.icon}
                  />
                  <InputLabel className={classes.label} id="driverName">
                    نام راننده
                  </InputLabel>
                </span>
                <span className={classes.inputHolder}>
                  <Controller
                    style={{width: '100%'}}
                    name="driverName"
                    control={control}
                    rules={{required: true}}
                    render={({onChange}) => (
                      <Autocomplete
                        id="driverName"
                        noOptionsText="موردی یافت نشد"
                        disableClearable
                        onChange={(event: any, newValue: any | null) => {
                          onChange(event);
                          handleSelectDriver(newValue.name);
                        }}
                        getOptionSelected={(option, value) =>
                          option.name === value.name
                        }
                        getOptionLabel={options => options.name}
                        options={
                          props.driverList.length ? props.driverList : []
                        }
                        loading={props.driversLoading}
                        loadingText="در حال بارگذاری"
                        renderInput={params => (
                          <TextField
                            {...params}
                            margin="normal"
                            placeholder={parcel?.driverName}
                            InputProps={{
                              ...params.InputProps,
                              type: 'search',
                              endAdornment: (
                                <React.Fragment>
                                  {props.driversLoading ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    )}
                  />
                  <FormHelperText error focused>
                    {errors.driverName && 'نام راننده الزامی است'}
                  </FormHelperText>
                </span>
              </div>
            </Grid>
            <Grid
              container
              item
              xs={12}
              sm={6}
              md={3}
              lg={3}
              alignItems="flex-end"
            >
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon
                    path={mdiKeyOutline}
                    size={1}
                    className={classes.icon}
                  />
                  <InputLabel className={classes.label} id="driverId">
                    شناسه راننده
                  </InputLabel>
                </span>
                <span className={classes.inputHolder}>
                  <Controller
                    style={{width: '100%'}}
                    name="driverId"
                    control={control}
                    disabled
                    as={<TextField type="text" />}
                  />
                </span>
              </div>
            </Grid>
            <Grid
              container
              item
              xs={12}
              sm={6}
              md={3}
              lg={3}
              alignItems="flex-end"
            >
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon
                    path={mdiKeyOutline}
                    size={1}
                    className={classes.icon}
                  />
                  <InputLabel className={classes.label} id="driverPhone">
                    موبایل راننده
                  </InputLabel>
                </span>
                <span className={classes.inputHolder}>
                  <Controller
                    style={{width: '100%'}}
                    name="driverPhone"
                    control={control}
                    disabled
                    as={<TextField dir="ltr" type="text" />}
                  />
                </span>
              </div>
            </Grid>
          </Grid>
        </Paper>
        <Grid container direction="row" justify="flex-end" alignItems="center">
          <Button
            variant="contained"
            color="secondary"
            aria-label="assignment"
            size="large"
            type="submit"
          >
            <Icon
              path={mdiPlusBoxMultipleOutline}
              size={1}
              className={classes.icon}
            />
            {`تخصیص سفارش به راننده`}
          </Button>
        </Grid>
      </form>

      <Dialog open={confirmModal} onClose={handleCloseConfirmModal}>
        <DialogContent style={{width: '600px'}}>
          <p>
            ایا از اختصاص محموله {props.match.params.id} به راننده{' '}
            {Data?.driverName} اطمینان دارید
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleAssignParcel}
            variant="outlined"
            color="primary"
            disabled={loading}
          >
            {`بله`}
          </Button>
          <Button
            onClick={handleCloseConfirmModal}
            variant="contained"
            color="primary"
            autoFocus
          >
            {`خیر`}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  parcel: makeSelectParcel(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  inventoryItems: makeSelectInventoryItemsList(),
  inventoryItemsLoading: makeSelectInventoryItemsLoading(),
  driversLoading: makeDriverLoading(),
  driverList: makeSelectDriversList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getParcelWithIdActionDispatch: (id: number) =>
      dispatch(getRonadParcelsWithIdAction({id})),
    getParcelInventoryItemDispatch: (payload: object) =>
      dispatch(getParcelInventoryItemsAction(payload)),
    clearnParcelInventoryItemsDispatch: () =>
      dispatch(cleanPercelInventoryItemsAction()),
    getDriversDipatch: (payload: object) => dispatch(getDriversAction(payload)),
    clearDriverListDispatch: () => dispatch(cleanDriverListAction()),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(PickupsDetails);
